module.exports = __webpack_public_path__ + "img/1-1.53813fc3.webp";